export default __webpack_public_path__ + "static/media/Ecommerce Gateway.591595df.yaml";